<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container">
					<div class="modal-body">
						<div class="modal-body-title">
							<h1 class="modal-body-title__text">{{ title }}</h1>
						</div>
						<div class="modal-body-description">
							<p class="modal-body-description__text">
								{{ description }}
							</p>
						</div>
						<slot></slot>

						<div class="modal-body-buttons">
							<ButtonTertiary
								v-if="secondaryLabel"
								class="modal-body-buttons__secondary"
								:label="secondaryLabel"
								size="sm"
								@click="$emit('secondaryClick')"
							/>
							<ButtonSecondary
								v-if="primaryLabel"
								:label="primaryLabel"
								:isDisabled="primaryDisabled"
								size="sm"
								@click="$emit('primaryClick')"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
import ButtonSecondary from '@/components/shared/Button/ButtonSecondary/ButtonSecondary.vue';
import ButtonTertiary from '@/components/shared/Button/ButtonTertiary/ButtonTertiary.vue';
export default {
	name: 'Modal',
	components: {
		ButtonSecondary,
		ButtonTertiary,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		description: {
			type: String,
			required: true,
		},
		primaryLabel: {
			type: String,
			required: false,
		},
		primaryDisabled: {
			type: Boolean,
			default: false,
		},
		secondaryLabel: {
			type: String,
			required: false,
		},
	},
};
</script>
<style lang="scss" scoped>
@import 'Modal.scss';
</style>
